import React, {  Component } from 'react';
import { connect } from 'react-redux'

/* Actions */
import { sendEmailSuccessDialog } from '../../redux/actions';

class EmailSpecOverlayDialogSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.sendEmailSuccessDialog(false);
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="emailSpecOverlayDialog1">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Success</h2>
                    <p>Email has been sent successfully.</p>
                    <form className="emailSpecForm" onSubmit={this.closeDialog.bind(this)}>
                        <div className="floatRight">
                            <input className="blueButton" type="submit" value="OK" />
                        </div>
                        <div className="clear" />
                    </form>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
    sendEmailSuccessDialog: (emailSendSuccessDialog) => dispatch(sendEmailSuccessDialog(emailSendSuccessDialog))
});

EmailSpecOverlayDialogSuccess = connect(mapStateToProps, mapDispatchToProps)(EmailSpecOverlayDialogSuccess);
export default EmailSpecOverlayDialogSuccess;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/emailSpecOverlayDialogSuccess.js